import { useRouter } from 'next/router';
import klaviyoConstants from '@/constants/klaviyo.constants';
import { useEffect, useRef } from 'react';
import useRecordUserSessionSinceCalled from '@/hooks/useRecordUserSessionSinceCalled';
import useBackendUser from '@/hooks/useBackendUser';

export function useSkuKlaviyoPopup() {
  const { data: user, isLoading: isUserLoading } = useBackendUser();
  const executed = useRef<boolean>(false);
  const elapsedTime = useRecordUserSessionSinceCalled(true);
  const router = useRouter();
  const { locale, query } = router;
  const { slug } = query;

  useEffect(() => {
    if (elapsedTime < 12 || isUserLoading) {
      return;
    }

    if (typeof window !== 'undefined' && !executed.current && slug && !user) {
      if (locale === 'es' || locale === 'it' || locale === 'fr') {
        const skuPopupConfig = klaviyoConstants.skuPopupConfigs.filter(
          config => config.slug === `/${slug}` && config.locale === locale
        );

        if (skuPopupConfig.length > 0) {
          try {
            window._klOnsite.push(['openForm', skuPopupConfig[0].form]);
          } catch (error) {
            console.error('[KlaviyoPopup] Error opening form:', error);
          }
          executed.current = true;
        }
      }
    }
  }, [locale, query.slug, router, slug, elapsedTime, user, isUserLoading]);

  return null;
}
